import { isKorpoRegisterMode, UnitCategoryCode } from 'cart-model';
import { useSelector } from 'react-redux';
import ProductWizardState from './ProductWizardState';

const useGetAvailableFundsByUnitCategory = () => {
  const { funds: allFunds, blockedFundIdns } = useSelector((state: ProductWizardState) => state.apiState);
  const registerMode = useSelector((state: ProductWizardState) => state.cartState.registerMode);
  const korpoData = useSelector((state: ProductWizardState) => state.cartState.korpoData);
  const isKorpo = isKorpoRegisterMode(registerMode);

  return (unitCategoryCode: UnitCategoryCode) => (isKorpo && korpoData != null
      ? allFunds.filter(f => korpoData.allowedFunds.map(af => af.fundId).includes(f.id))
      : allFunds)
      .filter(fund => {
        const afsCode = fund.afsCodeForUnitCode[unitCategoryCode];
        return !blockedFundIdns.includes(afsCode);
      })
      .filter(fund => fund.quotesForUnitCode[unitCategoryCode]);
}

export default useGetAvailableFundsByUnitCategory;